import React, { useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableToolbar from "components/MDTable/tableToolbar";
import TableHeader from "components/MDTable/tableHeader";
import { Order } from "components/MDTable/helper";
import { ITableHeader } from "types/Table";
import TablePaginationActions from "components/MDTable/tablePagination";
import MDBox from "components/MDBox";
import { useSelector } from "react-redux";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CircularProgress from "@mui/material/CircularProgress";
import { IconButton } from "@mui/material";
import { PaginationCommonObject } from "types/common";
import { getLoadingStatus } from "redux/slices/transactionSlice";
import { Overview } from "types/Overview";
import InputDebounce from "components/MDInput/inputDebounce";

type TableType = {
  header: ITableHeader[];
  rows: PaginationCommonObject<Overview>;
  onPageChanged: (newPage: number) => void;
  handleOverviewSearch: (searchInput: string) => void;
  onReload: () => void;
  viewOverview: (selectedOverview: Overview) => void;
};
const OverviewTable: React.FC<TableType> = (props) => {
  const {
    header,
    rows,
    onReload,
    handleOverviewSearch,
    viewOverview,
    onPageChanged,
  } = props;
  const { data } = rows;
  const [order, setOrder] = useState<Order>("desc");
  const [orderBy, setOrderBy] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const isLoading = useSelector(getLoadingStatus);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    onPageChanged(newPage);
    setPage(newPage);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableToolbar
          numSelected={0}
          tableName={"Overview"}
          onReload={onReload}
        />

        <MDBox>
          <InputDebounce
            type="text"
            name="name"
            placeholder="Enter username or user id"
            onChange={handleOverviewSearch}
            width={"70%"}
          />
        </MDBox>

        {isLoading ? (
          <MDBox display={"flex"} justifyContent={"center"} mt={3}>
            <CircularProgress color={"primary"} />
          </MDBox>
        ) : (
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <TableHeader
                numSelected={0}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={() => {}}
                onRequestSort={handleRequestSort}
                rowCount={data.length}
                headCells={header}
                disableCheckbox={true}
              />
              <TableBody>
                {data.map((row) => {
                  return (
                    <TableRow hover tabIndex={-1} key={row.id}>
                      <TableCell align="right">{row.id}</TableCell>
                      <TableCell align="right">{`${row.fname} ${row.lname}`}</TableCell>
                      <TableCell align="right">{row.total_points}</TableCell>
                      <TableCell align="right">{row.in_points}</TableCell>
                      <TableCell align="right">{row.out_points}</TableCell>
                      <TableCell align="right">{row.nett_points}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          onClick={(e) => {
                            //Prevent whole  row is being selected
                            e.stopPropagation();
                            e.preventDefault();
                            viewOverview(row);
                          }}
                        >
                          <OpenInNewIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <TablePagination
          rowsPerPageOptions={[15]}
          component="div"
          count={rows.total}
          rowsPerPage={rows.per_page}
          page={rows.total <= 0 ? 0 : page}
          onPageChange={handleChangePage}
          ActionsComponent={TablePaginationActions}
        />
      </Paper>
    </Box>
  );
};
export default OverviewTable;
